module.exports = __webpack_public_path__ + "static/media/alt-menu-background-2.c8d116b7.jpg";